import React from "react"

function Keypad(props) {
    const buttonTopNumbers = ["1", "2", "3", "4", "5"];
    const buttonBottomNumbers = ["6", "7", "8", "9", "0"];
    const keypadTop = buttonTopNumbers.map((index) => {
        return <button onClick={props.handleNumberClick} className="standardButton keypadButtons" key={index} name={index}>{index}</button>
    })
    const keypadBottom = buttonBottomNumbers.map((index) => {
        return <button onClick={props.handleNumberClick} className="standardButton keypadButtons" key={index} name={index}>{index}</button>
    })

    return (
        <div>
            {keypadTop}
            <br />
            {keypadBottom}
            <br />
            <button onClick={props.handleResetClick} className="standardButton keypadButtons">Reset</button>
        </div>
    )
}

export default Keypad